import 'jquery';
import { Settings } from '../Settings';
import { $window, $body, Breakpoints } from '../Constants';
import HtmlElement from './HtmlElement';
import Header from '../Elements/Header';

/**
 * Banner
 */
const Banner = (($) => {
  // Constants
  const DATA_KEY = 'ig.banner';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    BANNER: '.banner'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`
  };

  /**
   * Banner
   *
   * @class
   * @augments HtmlElement
   */
  class Banner extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this.adjustHeight();
      this._bindHandlers();
    }

    /**
     * Adjusts the height
     *
     * @return void
     */
    adjustHeight() {
      if (Settings.bannerAdjust || $window.width() < Breakpoints.MEDIUM) {
        this.$element.css('margin-top', Header.getHeight());
      }
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this.adjustHeight();
      });
    }
  }

  return Banner._getElement($body.find(Selector.BANNER), Banner);
})(jQuery);

export default Banner;
